import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {UserService} from '../../services';
import {UserRoles} from '../../enums';

@Injectable({
    providedIn: 'root'
})
export class UserRoleGuard implements CanActivate {
    private userService = inject(UserService);

    /* eslint-disable-next-line @typescript-eslint/no-unused-vars  */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.userService.userHasAnyRole(route.data.roles as UserRoles[]);
    }
}
